import { useMemo, useState, useEffect } from 'react';
import { INTEGRATION_LEAD_TYPES, NAME_OF_LEAD_TYPES, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { capitalizeWord } from 'helpers/sf_utils';
import useFeatureFlags from './useFeatureFlags';

/**
 * Custom hook to filter integration lead types based on feature flags
 * 
 * @returns {Object} An object containing:
 *  - leadTypes: Array of filtered lead type objects
 *  - copyLeadPayloadDropdownOptions: Array of dropdown options formatted as {label, value}
 */
const useFilteredIntegrationLeadTypes = () => {
  const [isFeatureFlagActive] = useFeatureFlags();

  const ltMotorcycleEnabled = useMemo(() =>
    isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_MOTORCYCLE_LEAD_TYPE_FOR_LEADS_AND_CALLS),
    [isFeatureFlagActive]
  );

  const ltGroupHealthEnabled = useMemo(() =>
    isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_GROUP_HEALTH_LEAD_TYPE),
    [isFeatureFlagActive]
  );

  const [leadTypes, setLeadTypes] = useState([]);
  const [copyLeadPayloadDropdownOptions, setCopyLeadPayloadDropdownOptions] = useState([]);

  useEffect(() => {
    const filteredLeadTypes = INTEGRATION_LEAD_TYPES.filter((lead_type) => {
      switch (lead_type.name) {
        case NAME_OF_LEAD_TYPES.MOTORCYCLE:
          return ltMotorcycleEnabled;

        case NAME_OF_LEAD_TYPES.GROUP_HEALTH:
          return ltGroupHealthEnabled;

        default:
          return true;
      }
    });

    setLeadTypes(filteredLeadTypes);
    setCopyLeadPayloadDropdownOptions(
      filteredLeadTypes.map(lt => ({ label: capitalizeWord(lt.name), value: lt.id }))
    );
  }, [ltGroupHealthEnabled, ltMotorcycleEnabled]);

  return { leadTypes, copyLeadPayloadDropdownOptions };
};

export default useFilteredIntegrationLeadTypes;
